import { Buttons, Text } from '@taxdown/piccolo-web';
import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { TaxReturnTypes, textsByType } from 'Containers/Result/utils';
import IconAmount from 'Containers/Result/components/IconAmount';
import MandatoryInfo from 'Containers/Result/components/MandatoryInfo';
import { ResultType } from 'Types/common';
import * as Styled from './styles';

export type ToReturnProps = {
  data: ResultType;
  onClick: () => void;
};
const ResultBox = ({ data, onClick }: ToReturnProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.RESULT);
  const { header, subheader, text, amountColor } = textsByType[data?.taxReturnType];

  return (
    <Styled.Box type={data?.taxReturnType}>
      <Styled.BoxContent direction="column" align="center" justify="center" gap="dimension_16">
        <Text type="paragraphs" align="center" size="XL_XL_S" color="dark">
          {t(header)}
        </Text>
        <Text type="paragraphs" align="center" size="L_L_S" color="dark">
          {t(subheader)}
        </Text>
        <Styled.AmountContainer align="center" justify="center">
          <IconAmount type={data?.taxReturnType} />
          <Text type="headline" size="M_L_S" color={amountColor}>
            {YayoyakiFormatter.formatAmountMxn(Math.abs(data?.taxReturnResult))}
          </Text>
          <IconAmount type={data?.taxReturnType} />
        </Styled.AmountContainer>
        <Text type="paragraphs" align="center" size="S_M_S" color="dark">
          {t(text)}
        </Text>
        {data.taxReturnType === TaxReturnTypes.TO_RETURN && (
          <Buttons.Classic
            label={t('Result.toReturn.button')}
            mode="primary"
            size="l"
            onClick={onClick}
          />
        )}
        {data.taxReturnType !== TaxReturnTypes.TO_RETURN && (
          <Buttons.Classic
            label={t('Result.notReturn.button')}
            mode="primary"
            size="l"
            onClick={onClick}
          />
        )}
      </Styled.BoxContent>
      {data.mandatory && <MandatoryInfo daInfo={data} />}
    </Styled.Box>
  );
};

export default ResultBox;
